import { render } from "./RecentRecipes.vue?vue&type=template&id=a8a85f00"
import script from "./RecentRecipes.vue?vue&type=script&lang=js"
export * from "./RecentRecipes.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__